import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import UserContext from './UserContext'; // assuming you'll use context for global auth


const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);

   const handleLogin = async (e) => {
    e.preventDefault();

     try {
    	const response = await fetch('/api/token/', {
      	method: 'POST',
      	headers: { 'Content-Type': 'application/json' },
      	body: JSON.stringify({ username, password })
     	});

    	if (response.ok) {
      		const data = await response.json();
      		localStorage.setItem('access', data.access);
      		localStorage.setItem('refresh', data.refresh);
      
      // ✅ Just store username - no need for artist_id!
      	setUser({ 
        	username, 
        	token: data.access 
      	});
      
      	navigate('/songs');
    	} else {
      	setMessage('Invalid credentials');
    	}
  	} catch (error) {
    	console.error('Login failed:', error);
    	setMessage('Something went wrong. Please try again.');
  	}
};    
        

  return (
    <div className="login-root">
      <div className="terminal-prompt">&gt;signalbleed.nyc</div>
      <h2>Login</h2>

      {message && <p className="error-message">{message}</p>}

      <form onSubmit={handleLogin}>
        <div className="form-group">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <input type="submit" value="Login" />
      </form>

      <p>Don't have an account? <a href="/register">Register here.</a></p>
      <p>Forgot password? No problemo!  <a href="/resetpassword/">Click here. </a></p>  
    </div>
  );
};

export default LoginPage;

